import React from 'react';
import '../../styles/components/AsperaImageRender.scss';
import { createInitials } from '../../helpers/helpers';
/**
 * React Component
 *
 * The AsperaImageRender creates the image used in DataTable and other components
 *
 * @example
 * ```javascript
 * <AsperaImageRender image={image} altText="Test User" />
 * ```
 */
export class AsperaImageRender extends React.Component {
    render() {
        const { className, image, altText, removeRadius, backupIcon } = this.props;
        const imageStyle = image ? {
            backgroundImage: `url(${image})`,
        } : {};
        return (React.createElement("div", { className: `aspera-image-render ${className ? className : ''}`, "data-auto": `table-image-render--${altText}` },
            React.createElement("div", { className: `image-wrapper ${image ? 'has-image' : ''} ${removeRadius ? 'no-image-radius' : ''}`, style: imageStyle, title: altText },
                !image && backupIcon ? React.createElement(backupIcon) : '',
                !image && !backupIcon ? React.createElement("span", { className: "backup-initials" }, createInitials(altText || '')) : '')));
    }
}
